import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import showIcon from '../../../assets/hideIcon.png';
import closeIcon from '../../../assets/showIcon.png';
import Divider from '../common/Divider';
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../services/operations/authAPI";
import Loader from '../../Loader/Loader';

const LoginPage = () => {
  const { register, handleSubmit, watch, formState: { errors }, trigger } = useForm({ mode: "onSubmit" });
  
  const [showPasswordToggle, setShowPasswordToggle] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);

  const emailValue = watch("email");
  const passwordValue = watch("password");

  const togglePasswordVisibility = () => {
    setShowPasswordToggle(prevState => !prevState);
  };

  const handleNextClick = async () => {
    const isValidEmail = await trigger("email");
    if (isValidEmail) {
      setShowPassword(true);
    }
  };

  const onSubmit = async (data,e) => {
    if (!showPassword) {
      e.preventDefault();
      handleNextClick();
    }

    const encodedPassword = btoa(data.password);
    const payload = { email: data.email, password: encodedPassword };
    await dispatch(Login(payload, navigate));
  };

  return (
    <div className="login-page">
      {loading && <Loader />}
      <Header />
      <form onSubmit={handleSubmit(onSubmit)} className="login-form">
      <div className="login-form-group">
    <label htmlFor="email" className="form-label">Email Address</label>
    <input
      type="text"
      id="email"
      autoComplete="username"
      className={`form-input-login ${errors.email ? "input-error" : ""}`}
      {...register("email", {
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: "Invalid email format",
        },
      })}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !showPassword) {
          e.preventDefault();
          handleNextClick();
        }
      }}
    />
    {errors.email && <p className="error-message">{errors.email.message}</p>}
  </div>
        
        {showPassword && (
          <div className="login-form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="password-wrapper">
              <input
                type={showPasswordToggle ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                style={{width:"100%"}}
                className={`form-input-login ${errors.password ? "input-error" : ""}`}
                {...register("password", { required: "Password is required" })}
              />
              <span className="password-toggle-icon" onClick={togglePasswordVisibility} style={{top:"40px",right:"20px"}}>
                <img src={showPasswordToggle ? showIcon : closeIcon} alt='toggle visibility' />
              </span>
            </div>
            {errors.password && <p className="error-message">{errors.password.message}</p>}
          </div>
        )}

        <button
          type={showPassword ? "submit" : "button"}
          className={`button-theme login-button ${!emailValue || (showPassword && !passwordValue) ? "button-disabled" : "button-enabled"}`}
          onClick={!showPassword ? handleNextClick : undefined}
          disabled={!emailValue || (showPassword && !passwordValue)}
        >
          {showPassword ? "Login" : "Next"}
        </button>
      </form>
      <br />
      <Divider />
      <p>Forgot your password? <span style={{ color: "rgba(45, 118, 253, 1)", fontWeight: "700", cursor: "pointer" }} onClick={() => navigate("/forget-password")}>Click here</span></p>
      <br /><br /><br /><br />
    </div>
  );
};

export default LoginPage;